import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "TopMenuContainer",
  inheritAttrs: true,
});

import { provide, watch, toRefs, ref } from "vue";
//import types
import type { Ref } from "vue";
import type { TopMenuContainerProps } from "@/typings";
//import injection symbols
import { deactivateMenuSymbol } from "@/injection/topMenu";
//import composables
import {
  useToggle,
  useModifiableProp,
  useDefaultValue,
} from "@toolsie/composables-reactivity";
import { useBreakpoint } from "@toolsie/composables-browser";
//import and define props
import { topMenuContainerProps as propsObject } from "@/props/topMenu";

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: propsObject,
  emits: ["update:active"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "update:active", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props: TopMenuContainerProps = __props

//import vue


let { active, breakpoint } = toRefs(props);
//define the emits


//get the active value as a modifiable prop
let isActive = useModifiableProp(
  active as Ref<boolean>,
  false,
  emits,
  "update:active"
);
//get the toggler for the isActive value
let { toggle: toggleMenu } = useToggle(isActive);

//provide the deactivation flag and watch it
/** @const deactivateMenuFlag */
const deactivateMenuFlag = ref(false);
//provide the flag with the symbol
provide(deactivateMenuSymbol, deactivateMenuFlag);
//watch the flag to toggle the menu in case it changes
watch(deactivateMenuFlag, () => toggleMenu(false));

let theBreakpoint = useDefaultValue(breakpoint, propsObject.breakpoint.default);
//get the mobileSize flag
let isMobileSize = useBreakpoint(theBreakpoint);
//get if the menu is fixed

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["toolsie-top-menu-container", {
      active: _unref(isActive),
      inactive: !_unref(isActive),
      responsive: _unref(isMobileSize),
      fixed: _ctx.fixed,
    }])
  }, [
    _renderSlot(_ctx.$slots, "default", { deactivateMenu: _unref(toggleMenu) }),
    _withDirectives(_createElementVNode("p", {
      href: "javascript:void(0);",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleMenu)())),
      class: _normalizeClass(["toolsie-top-menu-toggle", {
        left: _ctx.leftToggle,
        right: !_ctx.leftToggle,
      }])
    }, " ☰ ", 2), [
      [_vShow, _unref(isMobileSize)]
    ])
  ], 2))
}
}

})